export default {
  methods: {
    urlWithId(pathname) {
      const facilityId = this.$store?.state?.facilityId || this.facility?.id;
      return `${pathname}?id=${facilityId}`;
    },
  },
};
